import { React } from 'Imports';
import { useEffect, useState } from 'react';
import { ConfirmDialog } from '$Components/Shared/ConfirmDialog';
import { Alert } from 'MaterialUIComponents';
import { isEncompass } from '$Utilities/integrationPlatform';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const styles = require('./VideoRetention.scss') as {
    danger: string;
    confirmText: string;
    encompassConfirmText: string;
    encompassConfirmTextBold: string;
};
interface IVideoRetentionSaveDialogProps {
    isOpen: boolean;
    retentionDays: number;
    handleSubmit: () => void;
    handleModalClosed: () => void;
}

export const VideoRetentionSaveDialog = (props: IVideoRetentionSaveDialogProps) => {
    // submit state controls
    const [confirmDialogCancelText, setConfirmDialogCancelText] = useState('Cancel');
    const [confirmDialogAcceptText, setConfirmDialogAcceptText] = useState('Confirm');
    const [confirmDialogText, setConfirmDialogText] = useState<React.JSX.Element>(<></>);

    // geotab
    const geotabModalMessage = (numDays: number) => (
        <div>
            <div className={styles.confirmText}>Are you sure you want to change the video retention period?</div>
            <Alert icon={false} className={styles.danger}>
                All videos prior to {numDays == 1095 ? '3 years' : `${numDays} days`} from today will be permanently deleted.
            </Alert>
        </div>
    );

    const geotabCancelButtonText = 'Cancel';
    const geotabAcceptButtonText = 'Confirm';

    // encompass
    const encompassModalMessage = (numDays: number) => (
        <div style={{ marginTop: '24px' }}>
            <Alert icon={false} className={styles.danger}>
                <tr>
                    <td style={{ verticalAlign: 'middle' }}>
                        <FontAwesomeIcon icon={faTimesCircle} style={{ width: '32px', height: '28px', marginRight: '16px' }} />
                    </td>
                    <td style={{ verticalAlign: 'middle' }}>
                        <div className={styles.encompassConfirmText}>Are you sure you want to change the video retention period?</div>
                        <div className={styles.encompassConfirmTextBold}>
                            All videos prior to {numDays == 1095 ? '3 years' : `${numDays} days`} from today will be permanently deleted.
                        </div>
                    </td>
                </tr>
            </Alert>
        </div>
    );
    const encompassCancelButtonText = 'No, Go Back';
    const encompassAcceptButtonText = 'Yes, Confirm';

    // set the modal message to whatever the integration is
    const updateModalMessage = (days: number) => {
        setConfirmDialogText(isEncompass ? encompassModalMessage(days) : geotabModalMessage(days));
    };

    // initialize values
    useEffect(() => {
        setConfirmDialogCancelText(isEncompass ? encompassCancelButtonText : geotabCancelButtonText);
        setConfirmDialogAcceptText(isEncompass ? encompassAcceptButtonText : geotabAcceptButtonText);
    }, []);

    useEffect(() => {
        updateModalMessage(props.retentionDays);
    }, [props.retentionDays]);

    return (
        <ConfirmDialog
            isOpen={props.isOpen}
            title={isEncompass ? "Change Retention Period" : "Confirm Retention Change"}
            contentMessage={confirmDialogText}
            cancelButton={confirmDialogCancelText}
            acceptButton={confirmDialogAcceptText}
            handleSubmit={() => props.handleSubmit()}
            handleModalClosed={() => props.handleModalClosed()}
            maxWidth="504px"
            isButtonAlert={isEncompass}
        />
    );
};
